import { GroupByMode, newTaskSuffix } from '@griply/types';
import { getNewTaskPrefill } from '@griply/utils';
import React from 'react';
import { NewTaskRow } from 'shared/components/connected/new-task-row';
import {
  RenderItemProps,
  TaskListItemTypes,
} from 'shared/components/ui/virtualized-tree-list';

import { SectionHeader } from '../section-header/section-header';
import { TreeTaskCard } from '../tree-task-card';
import { useSectionRenderData } from './section-render-context';

export const SectionRenderItem: React.FC<RenderItemProps> = ({
  item,
  itemInstance,
  tree,
  isMultiSelectModifierPressed,
}) => {
  const {
    groupSettings,
    tasksMap,
    tasks,
    today,
    denseFormat,
    registerNewTaskInput,
    onAddTask,
  } = useSectionRenderData();

  const type = item.type;

  if (type === TaskListItemTypes.Task) {
    const task = tasksMap[item.sourceId];
    if (!task) {
      return null;
    }
    return (
      <TreeTaskCard
        task={task}
        tree={tree}
        item={itemInstance}
        tasks={tasks}
        isMultiSelectModifierPressed={isMultiSelectModifierPressed}
        displayDue={groupSettings.displayDue}
      />
    );
  }

  if (type === TaskListItemTypes.NewTask) {
    const sectionId = item.sourceId.replace(newTaskSuffix, '');
    const prefill = getNewTaskPrefill({
      groupByMode: GroupByMode.Section,
      groupSectionId: sectionId,
      groupSetting: groupSettings,
      today,
    });
    const setNewTaskInputRef = (element: HTMLDivElement | null) =>
      registerNewTaskInput(sectionId, element);
    return (
      <NewTaskRow
        goal={prefill.goalId}
        lifeArea={prefill.lifeAreaId}
        section={prefill.sectionId}
        startTime={null}
        duration={null}
        tags={prefill.tagIds}
        newTaskInputRef={setNewTaskInputRef}
      />
    );
  }

  if (type === TaskListItemTypes.Section) {
    const children = item.children ?? [];
    const taskCount = children.filter(
      (childId) => !childId.endsWith(newTaskSuffix),
    ).length;
    const handleAddTask = () => onAddTask(item.sourceId);
    return (
      <SectionHeader
        item={itemInstance}
        denseFormat={denseFormat}
        onUpdateSectionName={groupSettings.onUpdateSection}
        taskCount={taskCount}
        goalId={groupSettings.goalId}
        lifeAreaId={groupSettings.lifeAreaId}
        onAddTask={handleAddTask}
      />
    );
  }

  return null;
};
